export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-turnover-info',
  turnoverInput: 'partnerbasicinfo-turnover',
  ppsShareInput: 'partnerbasicinfo-pps-share',
}

export const TRANSLATION_KEYS_LARGE_FORMAT = {
  fieldLabel: 'partnerbasicinfo-turnover-lf',
}
